// extracted by mini-css-extract-plugin
module.exports = {"badgesWrap":"Badges_badgesWrap__V1YIS","badge":"Badges_badge__2ivjr","slide-in-out":"Badges_slide-in-out__M_0Wk","fade-in-out":"Badges_fade-in-out__f_ja3"};